module.exports = __webpack_public_path__ + "assets/modal-frags-redpack-91df3606.png";